export function HomeRoute() {
	return <p style={{ color: "white" }}>Welcome to the Comunic Console!</p>;
}
